//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lineCharts from '~/components/burstdetails/lineCharts.vue'
import mobileTab from '~/components/common/mobileTab.vue'
import breadCrumbs from '~/components/common/breadCrumbs.vue'
export default {
  components: {
    lineCharts, mobileTab, 'bread-crumbs': breadCrumbs
  },
  async asyncData ({ $api, store, route, error }) {
    try {
      const { rankData } = await $api.burstData.newMtRankService({ period: 1, sort: 'Balance', direct: 'DESC' })
      return { rankData }
    } catch (error) {}
  },
  data () {
    return {
      isRequest: true, // 表格接口节流
      sortNum: 2,
      imgArr: ['https://resources.interface003.com/cloud/img/earanking/up-arrow.svg', 'https://resources.interface003.com/cloud/img/earanking/up-arrow-active.svg', 'https://resources.interface003.com/cloud/img/earanking/down-arrow.svg', 'https://resources.interface003.com/cloud/img/earanking/down-arrow-active.svg'],
      isClick: 0, // 防止tab重复点击
      currentPage: 1, // 当前页
      newRankData: [], // 存储表格数据
      totalAssets: true, // 总资产(USD)当前排序
      totalProfit: true, // 总盈亏(USD)当前排序
      winRate: true, // 胜率当前排序
      earnings: true, // 收益率当前排序
      tabsIndex: 0, // 当前选中的tab下标
      tabsData: [ // tab数据
        { name: 'TYY_000655' },
        { name: 'TYY_000183' },
        { name: 'TYY_000182' },
        { name: 'TYY_000185' },
        { name: 'TYY_000110' }
      ],
      rankData: [] // 页面数据
    }
  },
  head () {
    return {
      title: this.$t('29075'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000643') },
        { name: 'Description', content: this.$t('29076') }
      ]
    }
  },
  created () {
    this.newRankData = this.rankData?.slice(0, 10)
  },
  methods: {
    mobileTab (item) {
      this.handleClick(item.index)
    },
    // 跳转详情页
    toDetails (id) {
      window?.open(`/${this.currLangCode()}/data/earanking/${id}.html`)
    },
    // 点击排序
    sortFn (num) {
      if (!this.isRequest) return false
      this.sortNum = num
      this.isRequest = false
      this.judgeApi()
    },
    // 判断传对应的参数
    judgeApi () {
      if (this.sortNum == 1) this.getData('Balance', 'ASC')
      else if (this.sortNum == 2) this.getData('Balance', 'DESC')
      else if (this.sortNum == 3) this.getData('CloseTradePL', 'ASC')
      else if (this.sortNum == 4) this.getData('CloseTradePL', 'DESC')
      else if (this.sortNum == 5) this.getData('RateWin', 'ASC')
      else if (this.sortNum == 6) this.getData('RateWin', 'DESC')
      else if (this.sortNum == 7) this.getData('RateReturn', 'ASC')
      else if (this.sortNum == 8) this.getData('RateReturn', 'DESC')
    },
    // 点击tab
    handleClick (index) {
      if (this.isClick == index) return false
      this.isClick = index
      this.tabsIndex = index
      this.judgeApi()
    },
    // 获取表格数据
    async getData (sort = 'Balance', direct = 'DESC') {
      const { rankData } = await this.$api.burstData.newMtRankClient({ period: this.tabsIndex > 3 ? 0 : this.tabsIndex + 1, sort, direct })
      this.rankData = rankData
      this.currentPage = 1
      this.newRankData = this.rankData?.slice(0, 10)
      this.isRequest = true
    },
    // 分页方法
    currentChange (num) {
      this.currentPage = num
      this.newRankData = this.rankData?.slice(10 * (num - 1), 10 * (num - 1) + 10)
    }
  }
}
